export const rootUrl = process.env.NODE_ENV === 'development' ? '' : `https://${window.location.host}`
